<template>
  <span
    :title="title"
    :class="[{ [$style.ellipsis]: noOfLineEllipsis > 0 }]"
    :style="{
      color,
      opacity,
      fontSize: fontSize + 'px',
      fontWeight,
      lineHeight,
      textAlign,
      ...(noOfLineEllipsis > 0 && {
        width,
        '-webkit-line-clamp': noOfLineEllipsis,
        '-webkit-box-orient': 'vertical',
        display: '-webkit-box',
        height
      })
    }"
  >
    <slot> </slot>
  </span>
</template>

<script>
export default {
  name: 'GoldcastText',
  props: {
    color: {
      type: String,
      default: 'black'
    },
    opacity: {
      type: Number,
      default: 1
    },
    fontSize: {
      type: Number,
      default: 14
    },
    fontWeight: {
      type: [String, Number],
      default: 'normal'
    },
    textAlign: {
      type: String,
      default: 'center'
    },
    lineHeightCustom: {
      type: String,
      default: null
    },
    noOfLineEllipsis: {
      type: Number,
      default: 0
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '100%'
    },
    title: {
      type: String,
      default: ''
    }
  },
  computed: {
    lineHeight() {
      return this.lineHeightCustom || this.fontSize + 3 + 'px';
    }
  }
};
</script>

<style lang="scss" module>
.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
